import { render, staticRenderFns } from "./PosterPreview.vue?vue&type=template&id=55f3dc24&scoped=true&"
import script from "./PosterPreview.vue?vue&type=script&lang=js&"
export * from "./PosterPreview.vue?vue&type=script&lang=js&"
import style0 from "./PosterPreview.vue?vue&type=style&index=0&id=55f3dc24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f3dc24",
  null
  
)

export default component.exports